import { HEADERS_JSON } from "@/common/api/config";
import { catchError } from "@/common/api/utils";
import { GATEWAY_URL } from "@/common/config";
import { UserProfileResponse } from "@/entities/profile/types";

export const fetchUserProfile = async (
  token: string,
): Promise<UserProfileResponse> => {
  try {
    const response = await fetch(
      `${GATEWAY_URL}/cabinet/profile?token=${token}`,
      {
        method: "GET",
        headers: HEADERS_JSON,
      },
    );
    catchError(response);
    return await response.json();
  } catch (error: any) {
    const message = error?.message || error?.error || JSON.stringify(error);
    throw new Error(`Что-то пошло не так:\n${message}`);
  }
};
